import { Injectable } from '@angular/core';
import { NotificationService } from 'lib/notification/index.js';
import { ItemType } from '../core/core.models.js';
import { Subject, map } from 'rxjs';
import { observableHelper } from 'lib/helpers/observable-helper.class.js';

type ItemWordMode = 'singular' | 'plural';

@Injectable({
	providedIn: 'root'
})
export class AppNotificationService {
	private readonly itemType: Record<ItemType, ItemWordMode> = {
		'Progress Type': 'singular',
		Activity: 'singular',
		Appointment: 'singular',
		Avatar: 'singular',
		Branding: 'singular',
		Client: 'singular',
		Diary: 'singular',
		Diet: 'singular',
		Exercise: 'singular',
		File: 'singular',
		Food: 'singular',
		Log: 'singular',
		Message: 'singular',
		Notes: 'plural',
		Package: 'singular',
		Profile: 'singular',
		Progress: 'singular',
		Schedule: 'singular',
		Session: 'singular',
		Task: 'singular',
		User: 'singular',
		Workout: 'singular',
		Analytics: 'plural'
	};

	private readonly notification = new Subject<string | undefined>();

	constructor(private readonly notificationService: NotificationService) {
		this.notification
			.pipe(
				observableHelper.notificationDebounceTime(),
				map((text) => {
					if (text) {
						this.createNotification(text);
					}
				})
			)
			.subscribe();
	}

	notify(text: string): void {
		this.notification.next(text);
	}

	notifyDeleted(itemType: ItemType): void {
		this.notify(`${itemType} ${this.getHasBeenOrHaveBeen(itemType)} deleted`);
	}

	notifySaved(itemType: ItemType): void {
		this.notify(`${itemType} ${this.getHasBeenOrHaveBeen(itemType)} saved`);
	}

	notifyUploaded(): void {
		this.notify(`File ${this.getHasBeenOrHaveBeen('File')} uploaded`);
	}

	notifyCreated(itemType: ItemType): void {
		this.notify(`${itemType} ${this.getHasBeenOrHaveBeen(itemType)} created`);
	}

	private getHasBeenOrHaveBeen(itemType: ItemType): string {
		if (this.itemType[itemType] === 'plural') {
			return `have been`;
		}
		return `has been`;
	}

	private createNotification(text: string): void {
		this.notificationService.open(text);
	}
}
